<template>
    <div>
    </div>
</template>

<script>
    import SiteService from "../services/SiteService";
    import PageService from "../services/PageService";

    export default {
        name: 'OpenSite',
        data () {
            return {
                model: webase.model,
                service: new SiteService()
            }
        },
        mounted() {
            if (this.$route.params.id) {
                let siteId = this.$route.params.id
                let appId = this.$route.params.appId

                this.service.get(siteId).then((website) => {
                    if(website.webpages.length === 0) {
                        let page = {
                            title: 'Home',
                            layout: {description: ''},
                            show_nav: true,
                            show_footer: true,
                            home_page: true,
                            website_id: 'TODO: need the website id!'
                        }

                        let pageService = new PageService()
                        pageService.create({page: page}).then((webpage) => {
                            // TODO: route to page
                            this.$router.push({ name: 'page-editor', params: {pageId: webpage.slug}})
                        }).catch((message) => {
                            console.log('error creating page')
                            console.log(message)
                        })

                    }
                    else {
                        let page = website.webpages[0]
                        this.$router.push({ name: 'page-editor', params: {pageId: page.slug}})
                    }
                }).catch((error) => {
                    console.log('Error loading website.')
                    console.log(error)
                })
            }
        }
    }
</script>

<style>

</style>
